<div #chartContainer class="jepto-scatter-chart-container"></div>
